// api/apiService.ts
import axios from 'axios';
import store from '../../redux/store';
import { logOut } from '../../redux/auth/authSlice';

const apiClient = axios.create({
    baseURL: (import.meta as any).env.VITE_API_URL,
    headers: {
        'Content-Type': 'application/json',
    },

});

apiClient.interceptors.request.use(config => {
    if (!config.headers) {
        config.headers = {};
    }
    
    // Get token from multiple possible locations
    let token = '';
    try {
        const userData = JSON.parse(localStorage.getItem('user') || '{}');
        token = userData.token || 
                localStorage.getItem('token') || 
                localStorage.getItem('authToken') || '';
    } catch (e) {
        token = localStorage.getItem('token') || 
                localStorage.getItem('authToken') || '';
    }
    
    config.headers.Authorization = `Bearer ${token}`;
    return config;
});

apiClient.interceptors.response.use(
    response => response,
    error => {
        if (error?.response?.status === 401) {
            store.dispatch(logOut());
            localStorage.removeItem('user');
            const lang = localStorage.getItem('i18nextLng') || 'en-us';
            const loginPath = lang === 'sv-se' ? '/e-postinloggning' : '/emaillogin';
            window.location.replace(`${loginPath}?lang=${lang}`);
        }
        return Promise.reject(error);
    }
);


export const get = async (url: string, params?: Record<string, any>) => {
    try {
        const res = await apiClient.get(url, { params });
        return res.data;
    } catch (error) {
        throw error;
    }
};

export async function post<T>(url: string, data?: any): Promise<T> {
    try {
        const response = await apiClient.post<T>(url, data);
        return response.data;
    } catch (error: any) {
        // If backend returned an error response with data, throw that
        if (error.response && error.response.data) {
            throw error;
        }
        throw error;
    }
}

export async function put<T>(url: string, data: any): Promise<T> {
    const response = await apiClient.put<T>(url, data);
    return response.data;
}

export async function del<T>(url: string, data?: any): Promise<T> {
    const response = await apiClient.delete<T>(url, { data });
    return response.data;
}